import * as React from 'react';
import { FormControlLabel } from '@mui/material';
import BaseCheckbox from '../../../BaseComponents/Checkbox';

import { useTheme } from '../../../theme';
import Tooltip from '../../../BaseComponents/Tooltip';
import cn from 'classnames';
import { SafeHtml } from '@shared/ui';

interface Props {
	className?: string;
	label: string;
	tooltipLabel?: React.ReactNode;
	isChecked: boolean;
	isTooltipOpen: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
	({ className, label, tooltipLabel, isChecked, isTooltipOpen, onChange }, ref) => {
		const { Checkbox: theme } = useTheme('Consents');

		return (
			<FormControlLabel
				classes={{ root: cn(className, theme.control), label: theme.label }}
				checked={isChecked}
				control={
					<Tooltip classes={{ popper: theme.popper }} title={tooltipLabel} open={isTooltipOpen}>
						<BaseCheckbox onChange={onChange} />
					</Tooltip>
				}
				label={<SafeHtml tag="div" className={theme.label} html={label} />}
				ref={ref}
			/>
		);
	}
);

export default Checkbox;
